import { format } from 'date-fns';
import { Trash2 } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import { type Column, DataTable } from '@/components/common/DataTable';
import { Button } from '@/components/ui/button';
import { whitelistStore } from '@/stores';
import type { WhitelistItem } from '@/types';

export const WhitelistTable = observer(() => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

  const handleDelete = (userId: string) => {
    setSelectedUserId(userId);
    setDeleteDialogOpen(true);
  };

  const confirmDelete = async () => {
    if (selectedUserId) {
      try {
        await whitelistStore.removeUserFromWhitelist(selectedUserId);
      } catch (error) {
        console.error('删除失败:', error);
      }
    }
    setSelectedUserId(null);
  };

  const columns: Column<WhitelistItem>[] = [
    {
      id: 'id',
      header: 'ID',
      accessor: (row) => <span className="font-mono text-sm">{row.id}</span>,
    },
    {
      id: 'userId',
      header: '用户ID',
      accessor: (row) => <span className="font-medium">{row.userId}</span>,
    },
    {
      id: 'createdAt',
      header: '创建时间',
      accessor: (row) => {
        // created_at 是秒级时间戳，需要乘以 1000 转换为毫秒
        const timestamp = row.createdAt * 1000;
        return format(new Date(timestamp), 'yyyy-MM-dd HH:mm:ss');
      },
    },
    {
      id: 'actions',
      header: '操作',
      accessor: (row) => (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => handleDelete(row.userId)}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      ),
    },
  ];

  return (
    <>
      <DataTable
        columns={columns}
        data={whitelistStore.whitelists}
        loading={whitelistStore.loading}
        emptyMessage="暂无白名单记录"
      />
      <ConfirmDialog
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
        title="确认删除"
        description={`确定要删除用户 ${selectedUserId} 的白名单记录吗？`}
        confirmText="删除"
        cancelText="取消"
        variant="destructive"
        onConfirm={confirmDelete}
      />
    </>
  );
});
